<template>
    <div class="main-content">
        <div class="article">
            <template v-if="guide.article.bodyList && guide.article.bodyList.length">
                <template v-for="item in guide.article.bodyList">
                    <div class="content" v-if="item.type === 'static'" v-html="getBody(item.data)"></div>
                    <mvtLazyload data-nosnippet v-if="item.type === 'listings' && item.data && item.data.length" data-role="propertycard">
                        <mvtListProperty :data="item.data"></mvtListProperty>
                    </mvtLazyload>
                </template>
            </template>

            <div class="footer">
                <div class="introduce">
                    <div>
                        Who is <a class="link" :href="glb.appUrl">Movoto Real Estate</a>, you might ask?
                        Movoto is an online real estate brokerage based in San Mateo, CA. Our blog has
                        been recognized for its unique approach to Our blog has been
                        recognized for its unique approach to city-based research by
                        <a class="link" :href="glb.appUrl + 'blog/what-the-internet-says-about-us/'">major news organizations</a>
                        around the world such as Forbes and CBS News.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./guide-articlecontent.js"></script>

<style lang="scss">
@use './guide-articlecontent.scss' as *;
</style>
